var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLogout = function SvgIconLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_13090)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.14 15.8119L23.8988 20.055L22.485 18.6413L24.2494 16.875H15V15H24.5438L22.485 12.9412L23.8988 11.5275L28.14 15.7687L28.1194 15.7913L28.14 15.8119ZM20.625 5.625C20.625 5.12772 20.4275 4.65081 20.0758 4.29917C19.7242 3.94754 19.2473 3.75 18.75 3.75H5.625C5.12772 3.75 4.65081 3.94754 4.29917 4.29917C3.94754 4.65081 3.75 5.12772 3.75 5.625V24.375C3.75 24.8723 3.94754 25.3492 4.29917 25.7008C4.65081 26.0525 5.12772 26.25 5.625 26.25H18.75C19.2473 26.25 19.7242 26.0525 20.0758 25.7008C20.4275 25.3492 20.625 24.8723 20.625 24.375V22.5H22.5V24.375C22.5 25.3696 22.1049 26.3234 21.4016 27.0266C20.6984 27.7299 19.7446 28.125 18.75 28.125H5.625C4.63044 28.125 3.67661 27.7299 2.97335 27.0266C2.27009 26.3234 1.875 25.3696 1.875 24.375V5.625C1.875 4.63044 2.27009 3.67661 2.97335 2.97335C3.67661 2.27009 4.63044 1.875 5.625 1.875H18.75C19.7446 1.875 20.6984 2.27009 21.4016 2.97335C22.1049 3.67661 22.5 4.63044 22.5 5.625V9.375H20.625V5.625Z",
    fill: "#71717A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_13090"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
};
export default SvgIconLogout;